module.exports = __webpack_public_path__ + "509ce98f0da118c32d1199265caf6c58.MP3";